import React from 'react';
import type { User, BusinessUser } from '../../../../types/usersDemo';
import { HeadingSmall } from 'baseui/typography';
import { getStatusColor } from '../../utils/helpers';
import { mockInvitations } from '../../../../data/mock/usersDemo';

interface ActivityTabProps {
  contact: User | BusinessUser;
}

export const ActivityTab: React.FC<ActivityTabProps> = ({ contact }) => {
  return (
    <div>
      <HeadingSmall style={{ margin: '0 0 16px 0', color: '#666' }}>Recent Activity</HeadingSmall>
      <div style={{ overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
              <th style={{ padding: '8px', textAlign: 'left' }}>#</th>
              <th style={{ padding: '8px', textAlign: 'left' }}>Type</th>
              <th style={{ padding: '8px', textAlign: 'left' }}>Main Guest</th>
              <th style={{ padding: '8px', textAlign: 'left' }}>Destination</th>
              <th style={{ padding: '8px', textAlign: 'left' }}>Dates</th>
              <th style={{ padding: '8px', textAlign: 'left' }}>Host</th>
              <th style={{ padding: '8px', textAlign: 'left' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {mockInvitations.slice(0, 10).map((invitation, index) => (
              <tr key={invitation.id} style={{ borderBottom: '1px solid #f1f3f4' }}>
                <td style={{ padding: '8px' }}>{index + 1}</td>
                <td style={{ padding: '8px' }}>
                  <span style={{
                    fontSize: '12px',
                    color: invitation.type === 'Guest' ? '#2D7738' :
                           invitation.type === 'Supplier' ? '#1D4ED8' : '#B7791F',
                    fontWeight: '500',
                    textTransform: 'capitalize'
                  }}>
                    {invitation.type}
                  </span>
                </td>
                <td style={{ padding: '8px', fontWeight: '500' }}>{invitation.mainGuest}</td>
                <td style={{ padding: '8px', color: '#666' }}>{invitation.destination}</td>
                <td style={{ padding: '8px', color: '#888' }}>{invitation.dates}</td>
                <td style={{ padding: '8px', color: '#666' }}>{invitation.host}</td>
                <td style={{ padding: '8px' }}>
                  <div
                    style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      backgroundColor: getStatusColor(invitation.status) === 'positive' ? '#E8F5E8' :
                                     getStatusColor(invitation.status) === 'warning' ? '#FFF4E6' : '#FDE8E8',
                      color: getStatusColor(invitation.status) === 'positive' ? '#2D7738' :
                             getStatusColor(invitation.status) === 'warning' ? '#B7791F' : '#C53030',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'center',
                      minWidth: '60px'
                    }}
                  >
                    {invitation.status}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActivityTab;


